document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function(e) {
  if (e.target.classList.contains('qtyUpdate')) {
    e.preventDefault();

    const qtyButton = e.target;
    const parent = qtyButton.parentElement;
    const input = parent.querySelector('input');
    let curval = parseInt(input.value, 10);

    console.log(curval);

    if (qtyButton.classList.contains('qtyplus')) {
      curval += 1;
      input.value = curval;
    } else if (qtyButton.classList.contains('qtyminus')) {
      if (curval >= 1) {
        curval -= 1;
        input.value = curval;
      }
    }
  }
});


 var Featuredcolumn = new Swiper(".featured_slide", {
    slidesPerView: 1.3,
    spaceBetween: 20,
    autoHeight: true,
    centeredSlides: false,
          navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
       pagination: {
        el: ".swiper-pagination",
      },
    breakpoints: {
      550: {
        slidesPerView: 1.1,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  });

   var Logoslider = function () {
    document.querySelectorAll(".logo_slider").forEach(function (el) {
    if (el.swiper) el.swiper.destroy(true, true);
    // Swiper needs at least 2x the widest slidesPerView (6) to loop; with
    // fewer it drops loop silently and slides sit flush left, so fall back
    // to rewind and center them instead.
    var slideCount = el.querySelectorAll(".swiper-slide").length;
    var canLoop = slideCount >= 12;
    new Swiper(el, {
      slidesPerView: 3,
      spaceBetween: 26,
      loop: canLoop,
      rewind: !canLoop,
      centerInsufficientSlides: !canLoop,
      centeredSlides: false,
      autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
         pagination: {
          el: ".swiper-pagination",
        },
      breakpoints: {
        550: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        980: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
      },
    });
  });
  };
  Logoslider();

    var Videoslider = new Swiper(".video_slider", {
      slidesPerView: 1.3,
      spaceBetween: 15,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        550: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        980: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
      on: {
        slideChange: function () {
          const allSlides = document.querySelectorAll('.video_slider .swiper-slide');

          allSlides.forEach((slide) => {
            const video = slide.querySelector('video');
            const playIcon = slide.querySelector('.play-btn_video, .video-overlay');

            if (video && !video.paused) {
              video.pause();
              video.currentTime = 0;

              // Show play icon again
              if (playIcon) {
                playIcon.style.display = 'flex'; // or use a class like .active
              }
            }
          });
        }
      }
    });


    // Initialize thumbnail swiper first
    const thumbSwiper = new Swiper('.thumb_slide', {
      spaceBetween: 10,
      slidesPerView: 4.2,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        550: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        980: {
          slidesPerView: 3,
          spaceBetween: 5,
        },
        1200: {
          slidesPerView: 4.2,
          spaceBetween: 10,
        },
      },
    });

    // Then initialize the main swiper and link to thumbnail swiper
    const mediaSwiper = new Swiper('.media_slide', {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });


      const banSlider = new Swiper('.ban_slider', {
      spaceBetween: 10,
      slidesPerView: 1.3,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        550: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        980: {
          slidesPerView: 3,
          spaceBetween: 5,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
      },
    });
});



  $(document).on('shopify:section:load', function (event) {
    Featuredcolumn();
    Logoslider();
    Videoslider();
    thumbSwiper();
    thumbSwiper();
  });

  
  
 
